"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaskHealthApplicable = void 0;
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Task health check types shared by the backend endpoint and the task detail page.
const dbschema_1 = require("@karya/dbschema");
/**
 * Health checks apply to manual tasks that are live (in preview or submitted).
 * Autotransform tasks (`taskType` AUTO) are server-side and have no worker-facing health to report.
 */
const isTaskHealthApplicable = (task) => (task.status === 'PREVIEW' || (0, dbschema_1.isLiveTaskStatus)(task.status)) && task.params.taskType !== 'AUTO';
exports.isTaskHealthApplicable = isTaskHealthApplicable;
//# sourceMappingURL=Health.js.map